enum AppointmentWaitTimeCategory {  
  Unknown = "Unknown",
  Preventive = "Preventive Care Appointment",
  RoutineDiagnostic = "Routine/Diagnostic Care Appointment",  
  Urgent = "Urgent Care Appointment",
  Specialty = "Specialty Care Appointment"
}

export { AppointmentWaitTimeCategory }